import { Renderer } from '@unseenco/taxi';
import { isDEVMODE, viewStorage } from '../_globals'
import WknPlyr from '../modules/wkn-plyr'
import WknSwiper from '../modules/wkn-swiper'
import VimeoPlayer from '../modules/vimeo-player'
import DiscoverMoreBrands from '../modules/discover-more-brands'
import EcosystemList from '../modules/ecosystem-list'
import { CountUp } from '../modules/countUp.js'
import { gsap } from 'gsap'

export default class DefaultPageRenderer extends Renderer {

  initialLoad() {

    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)

  }

  onEnter() {
    this.DOM = {
      plyr: viewStorage.current.querySelector('.plyr__container'),
      vimeo: viewStorage.current.querySelector('.VimeoPlayer'),
      sectionEcosystem: viewStorage.current.querySelector('.section--ecosystem'),

      areasOfActionSwiper: viewStorage.current.querySelector('.section--areas-of-action .swiper'),

      counters: [...viewStorage.current.querySelectorAll('.js-count-up')],
      sectionNumberCols: [...viewStorage.current.querySelectorAll('.section--numbers .col')],
      
      // Ecosystem list
      homeContainer: document.querySelector('.Home'),

      swiperCitations: viewStorage.current.querySelector('.swiperCitations'),
    }

    // Ecosystem list vars (copied from our-ecosystem.js)
    if (this.DOM.homeContainer && this.DOM.homeContainer.dataset.urlajax) {
      this.urlajax = this.DOM.homeContainer.dataset.urlajax;
      this.page = 1;
      this.term_slug = 'members';
    }

    console.log(this.DOM.areasOfActionSwiper)

    this.init()
  }

  init() {
    const { 
      plyr = null,
      vimeo = null,
      sectionEcosystem = null,

      areasOfActionSwiper = null,
      counters = [],
      sectionNumberCols = [],
      swiperCitations = null,
    } = this.DOM

    // brands
    if (sectionEcosystem) this.DiscoverMoreBrandsModule = new DiscoverMoreBrands(sectionEcosystem)

    // init plyr
    if (plyr) this.plyr = new WknPlyr(plyr) 

    // Init Vimeo
    if (vimeo) this.vimeoPlayer = new VimeoPlayer(vimeo)

    // Init AOA Swiper
    if (areasOfActionSwiper) {
      this.areasOfActionSwiperModule = new WknSwiper(areasOfActionSwiper, { 
        slidesPerView: 'auto' 
      })
    }

    // Numbers
    if (sectionNumberCols.length) this.setNumber()

    // Init Ecosystem List
    if (this.urlajax) {
      this.ecosystemList = new EcosystemList(this.DOM.homeContainer, this.urlajax)
    }

    if (swiperCitations) this.swiperCitationsModule = new WknSwiper(swiperCitations)
  }

  /**
   * Numbers
   */
  countStart(){
    const { counters, sectionNumberCols } = this.DOM

    const options = {
      useEasing: true,
      useGrouping: true,
      separator: " ",
      decimal: "."
    }

    gsap.to(sectionNumberCols, { opacity: 1})
      
    counters.forEach( (item) => {
      const value = item.dataset.value
      const counter = new CountUp(item, value, options)
      counter.start()
    })
  }

  setNumber() {
    const { sectionNumberCols } = this.DOM

    gsap.set(sectionNumberCols, { opacity: 0})

    new Waypoint({
      element: sectionNumberCols[0],
      handler: () => this.countStart(),
      offset: '50%'
    })
  }

  onLeaveCompleted() {
    this.ecosystemList && this.ecosystemList.destroy()
    this.plyr && this.plyr.destroy()
    this.DiscoverMoreBrandsModule && this.DiscoverMoreBrandsModule.destroy()

    this.vimeoPlayer && this.vimeoPlayer.destroy()

    this.areasOfActionSwiperModule && this.areasOfActionSwiperModule.destroy()

    this.swiperCitationsModule && this.swiperCitationsModule.destroy()
  }
}
